// extracted by mini-css-extract-plugin
export default {"contentWrapper":"OnboardingPage_contentWrapper__x+cmf"};